import React from "react";
import style from "./style.module.css";

const CardTeam = ({ teamState }) => {
  const teamData = teamState.team;
  console.log(`Team Data: ${teamData}`);

  return (
    <>
      <div className={style.autoContainers}>
      {/* <h1 className="text-center ">Our Team</h1> */}
        {/* <!-- Row with cards --> */}
        <div className="row clearfix" >
          {teamData.map((member, index) => {
            return (
              <div className="col-sm-12 col-md-6 col-lg-6" >
                <div className={style.directorsBlock}>
                  <div className="row g-1 clearfix">
                    <div className="col-lg-5 col-md-12 col-sm-12">
                      <div className="image-box">
                        <figure className="image">
                          <img key = {`member_img-${index}`}  src={member.img} style={{maxWidth:"100%", height: "auto"}} alt={member.name} />
                        </figure>
                      </div>
                    </div>
                    
                    <div className="col-lg-7 col-md-12 col-sm-12">
                      <div className={style.directorsDetail}>
                        <p className="cardTitle">{member.name}</p>
                        <br/>
                        <div className="cardDetails">
                          <p >{member.position}</p>
                          <br/>
                        </div>


                      </div>
                    </div>

                  </div>
                </div>
              </div>
            );
          })}
        </div>
        {/* <!-- End of row with cards --> */}
      </div>
    </>
  );


};

export default CardTeam;
